export const LG_BREAKPOINT = 1024;
export const MD_BREAKPOINT = 768;
export const SM_BREAKPOINT = 512;
export const XL_BREAKPOINT = 1280;
export const XS_BREAKPOINT = 320;
export const XXL_BREAKPOINT = 1440;
